<template>
  <section>
    <!-- Vaginal Anatomy question -->
    <p v-if="showSubtitle" class="text-base -mt_4">
      {{ $t('onboardingbloom_subtitle_viginal_anatomy') }}
    </p>
    <div class="vaginal-container">
      <sword-radio-group-wuk
        :checked="vaginalAnatomyCoalesced"
        name="vaginal-anatomy"
        data-testid="input_vaginalAnatomy"
        :label="$t('onboardingbloom_question_viginal_anatomy')"
        :options="vaginalOptions"
        :validation="validations.vaginalAnatomy"
        @change="$emit('update:vaginalAnatomy', $event)"
      />

      <div class="pod-container">
        <div class="pod-box">
          <div class="pod-title">
            {{ $t('eco_bloom_pod') }}
          </div>
          <div class="pod-label hidden-desktop">
            {{ $t('onboardingbloom_label_sensor') }}
          </div>
        </div>
        <img src="@/assets/images/bloom/podStep.png" alt="" />
        <div class="pod-label hidden-mobile">
          {{ $t('onboardingbloom_label_sensor') }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import SwordRadioGroupWuk from '@ui-kit/components/inputs/radios/SwordRadioGroup.vue';
import { vaginalOpts } from '@/scripts/constants/vaginal-anatomy-configs';

export default {
  name: 'VaginalAnatomyField',
  components: {
    SwordRadioGroupWuk,
  },
  props: {
    vaginalAnatomy: {
      type: [String, null],
      default: null,
    },
    validations: {
      type: Object,
      default: () => ({
        vaginalAnatomy: {},
      }),
    },
    showSubtitle: Boolean,
  },
  data() {
    return {
      vaginalOptions: vaginalOpts,
    };
  },
  computed: {
    vaginalAnatomyCoalesced() {
      // looks like some local setups throw a build error
      // when coalescing directly in the html template
      // so we'll just use a computed prop to prevent that
      return this.vaginalAnatomy ?? '';
    },
  },
};
</script>

<style lang="scss" scoped>

.pod-container {
  display: flex;
  padding: 1rem;
  border-radius: 1rem;
  gap: 1rem;
  background-color: #fff2ee;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;

  img {
    max-height: 70px;
    max-width: 100px;
  }

  .pod-title {
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .pod-label {
    font-size: 0.75rem;
    font-weight: 500;
  }
}

@media screen and (min-width: $tablet-size) {
  .pod-container {
    flex-direction: column;
    text-align: center;
    max-width: 180px;
    margin-top: 52px;
    margin-bottom: 20px;

    img {
      max-width: 160px;
      max-height: 100px;
    }
  }

  .vaginal-container {
    display: flex;
    gap: 1.5rem;
  }
}
</style>
